module.exports = __webpack_public_path__ + "img/card.ef6d6c51.svg";